import { useState, useEffect, useCallback, useRef, useLayoutEffect, useMemo } from 'react';
import { Form, Input, Button, Space, Dropdown, Table, message, Modal, TreeSelect, Drawer, Divider, Flex, Tooltip } from 'antd';
import { filterFormItemLayout, pageFormItemWithoutLabelGridLayout, drawerWidth } from '@utils/property';
import { fullPagerConfig } from '@/utils/property';
import { useFilterPanelVisible } from '@/hooks/useFilterPanelVisible';
import { useTableScrollY } from '@/hooks/useTableScrollY';
import { useEnableTableScrollYLayout } from '@/layouts/tableScrollLayout';
import { useHorizontalScrollGuard } from '@/hooks/useHorizontalScrollGuard';
import { useVerticalScrollShadow } from '@/hooks/useVerticalScrollShadow';
import PageHeader from '@components/PageHeader/PageHeader';
import ChannelFilterPanel from './ChannelFilterPanel';
import './Channel.less';
import QRCode from 'qrcode.react';
import { get, post, put } from '@/core/request';
import { filterTreeNodeByTitle } from '@/utils/antdTreeSelect';

export default function OperationChannel() {
    const [isShowDrawer, setIsShowDrawer] = useState(false);
    const [isShowEdit, setIsShowEdit] = useState(false);
    const [isShowNewChannel, setIsShowNewChannel] = useState(false);
    const [treeData, setTreeData] = useState(null);
    const [treeDataDisabled, setTreeDataDisabled] = useState(null);
    const [list, setList] = useState(null);
    const [form2] = Form.useForm();
    const [form3] = Form.useForm();
    const [formUrl] = Form.useForm();
    const [isShowCode, setIsShowCode] = useState(false);
    const [codeValue, setCodeValue] = useState('');
    const [ulrList] = useState(['https://usercenter.cn-healthcare.com/certificate', 'https://ucenter.cn-healthcare.com/rlogin/tologin?redirectUrl=https://www.cn-healthcare.com/', 'https://www.cn-healthcare.com/z/membership_center/pc/buy_vip.html']);
    const [title, setTitle] = useState('');
    const [id, setId] = useState('');
    const [channelType, setChannelType] = useState('');
    const [status, setStatus] = useState('');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(20);
    const [channelInformation, setChannelInformation] = useState('');
    let [num, setNum] = useState(0);
    const [recordId, setRecordId] = useState(null);
    const [dataList, setDataList] = useState(null);
    const [createdByStaffId, setCreatedByStaffId] = useState('');
    const { filterToggleProps, FilterPanelSlot } = useFilterPanelVisible();

    const tableRegionRef = useRef(null);
    const tableScrollContainerRef = useRef(null);
    const [scrollContainerVersion, setScrollContainerVersion] = useState(0);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const enableTableScrollYLayout = useEnableTableScrollYLayout();
    const tableDeductSelectors = useMemo(() => ['.channel-list-table-toolbar'], []);
    const tableScrollY = useTableScrollY(tableRegionRef, {
        enabled: enableTableScrollYLayout || isFullscreen,
        heightRootClassName: 'main-container-card',
        scrollYOffset: 0,
        deductSiblingSelectors: tableDeductSelectors,
    });

    useHorizontalScrollGuard(tableScrollContainerRef, {
        threshold: 6,
        edgeHoldMs: 220,
        watchValue: scrollContainerVersion,
    });
    useVerticalScrollShadow(tableScrollContainerRef, {
        threshold: 2,
        watchValue: scrollContainerVersion,
    });

    useLayoutEffect(() => {
        const region = tableRegionRef.current;
        if (!region) return;

        const resolveScrollContainer = () => {
            const next = region.querySelector('.ant-table-body') ?? region.querySelector('.ant-table-content');
            if (tableScrollContainerRef.current !== next) {
                tableScrollContainerRef.current = next;
                setScrollContainerVersion(v => v + 1);
            }
        };

        resolveScrollContainer();

        let rafId = 0;
        const mutationObserver = new MutationObserver(() => {
            if (rafId) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(() => {
                rafId = 0;
                resolveScrollContainer();
            });
        });
        mutationObserver.observe(region, { childList: true, subtree: true });

        return () => {
            if (rafId) cancelAnimationFrame(rafId);
            mutationObserver.disconnect();
        };
    }, []);

    const handleToggleFullscreen = useCallback(() => {
        const target = document.querySelector('main.main-container');
        if (!target) return;
        const next = !target.classList.contains('is-page-fullscreen');
        target.classList.toggle('is-page-fullscreen', next);
        setIsFullscreen(next);
    }, []);

    useEffect(() => {
        const onKeyDown = e => {
            if (e.key !== 'Escape') return;
            const target = document.querySelector('main.main-container.is-page-fullscreen');
            if (!target) return;
            target.classList.remove('is-page-fullscreen');
            setIsFullscreen(false);
        };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, []);

    useEffect(() => {
        return () => {
            const target = document.querySelector('main.main-container.is-page-fullscreen');
            if (target) target.classList.remove('is-page-fullscreen');
        };
    }, []);

    useEffect(() => {
        document.title = '渠道管理-运营中心';
    }, []);

    const fetchList = useCallback(() => {
        get(`/channel/channel/page?status=${status}&id=${id}&title=${title}&channelType=${channelType}&page=${page}&limit=${limit}&createdByStaffId=${createdByStaffId}`).then(
            res => {
                setList(res.data);
            },
            err => {
                console.log(err);
            },
        );
    }, [page, limit, channelType, createdByStaffId, id, status, title]);

    useEffect(() => {
        fetchList();
    }, [fetchList]);

    const filter = useMemo(() => ({ title, id, channelType, status, createdByStaffId }), [title, id, channelType, status, createdByStaffId]);

    const onFinish = values => {
        setTitle(values.title || '');
        setId(values.id || '');
        setChannelType(values.channelType || '');
        setStatus(values.status === undefined ? '' : values.status);
        setCreatedByStaffId(values.createdByStaffId || '');
        setPage(1);
        setNum(++num);
    };

    const onReset = () => {
        setPage(1);
        setTitle('');
        setId('');
        setChannelType('');
        setStatus('');
        setCreatedByStaffId('');
        setNum(++num);
    };

    const [valueSelectEdit, setValueSelectEdit] = useState(undefined);
    const [valueSelectChannel, setValueSelectChannel] = useState(undefined);

    const onChangeTreeSelectEdit = value => {
        setValueSelectEdit(value);
    };
    const onChangeTreeSelectChannel = value => {
        setValueSelectChannel(value);
    };

    const deepClone = useCallback(result => {
        if (result == null) {
            return;
        }
        if (result?.length) {
            return result.map(item => {
                item.title = item.name;
                item.value = item.id;
                if (item.children.length) {
                    deepClone(item.children);
                }
                return item;
            });
        }
    }, []);

    useEffect(() => {
        get('/channel/channel-group/listTree').then(
            res => {
                if (res.status_code === 200) {
                    setTreeData(deepClone(res.data));
                }
            },
            err => {
                console.log(err);
            },
        );
        get('/channel/user/findAll').then(
            res => {
                if (res.status_code === 200) {
                    setDataList(res.data);
                }
            },
            err => {
                console.log(err);
            },
        );
    }, [deepClone]);

    const deepCloneDisabled = useCallback(result => {
        if (result == null) {
            return;
        }
        for (let i = 0; i < result.length; i++) {
            result[i].title = result[i].name;
            result[i].value = result[i].id;
            result[i].disabled = true;
            if (result[i].children.length) {
                result[i].children.forEach(item => {
                    item.title = item.name;
                    item.value = item.id;
                    item.disabled = true;
                    if (item.children.length) {
                        for (let m = 0; m < item.children.length; m++) {
                            item.children[m].title = item.children[m].name;
                            item.children[m].value = item.children[m].id;
                        }
                    }
                });
            }
        }
        return result;
    }, []);

    useEffect(() => {
        get('/channel/channel-group/listTree').then(
            res => {
                if (res.status_code === 200) {
                    const result1 = deepCloneDisabled(res.data);
                    setTreeDataDisabled(result1);
                }
            },
            err => {
                console.log(err);
            },
        );
    }, [deepCloneDisabled]);

    const handleCancelEdit = () => {
        setIsShowEdit(false);
        setValueSelectEdit(undefined);
        form2.resetFields();
    };

    const handleCancelChannel = () => {
        setIsShowNewChannel(false);
        setValueSelectChannel(undefined);
        form3.resetFields();
    };

    const onFinishChannel = values => {
        post('/channel/channel/save', values).then(res => {
            if (res.status_code === 200) {
                setIsShowNewChannel(false);
                form3.resetFields();
                setNum(++num);
            }
        });
    };

    const newChannels = () => {
        setIsShowNewChannel(true);
    };

    const handleEditClick = record => {
        setRecordId(record.id);
        setIsShowEdit(true);
        form2.setFieldsValue({ position2: record.position2, title: record.title });
    };

    const onFinishEdit = values => {
        put('/channel/channel/edit-info', {
            id: recordId,
            title: values.title,
            position2: values.position2,
        }).then(res => {
            if (res.status_code === 200) {
                form2.resetFields();
                setNum(++num);
                setIsShowEdit(false);
            }
        });
    };

    const handleGenerateChannelLink = record => {
        setChannelInformation(record);
        setIsShowDrawer(true);
    };

    const handleDisableChannel = record => {
        Modal.confirm({
            title: '禁用渠道',
            content: '禁用渠道后，推广效果将不再收集统计，确定禁用？',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                put(`/channel/channel/edit-status`, {
                    id: record.id,
                    deleteStatus: 1,
                }).then(res => {
                    if (res.status_code === 200) {
                        message.info(res.message);
                        fetchList();
                    }
                });
            },
        });
    };

    const handleEnableChannel = record => {
        put(`/channel/channel/edit-status`, {
            id: record.id,
            deleteStatus: 0,
        }).then(res => {
            if (res.status_code === 200) {
                message.info(res.message);
                fetchList();
            }
        });
    };

    const columns = [
        { title: '渠道ID', dataIndex: 'id', key: 'id' },
        { title: '渠道名称', dataIndex: 'title' },
        {
            title: '渠道分类',
            dataIndex: 'deleteStatus',
            render: (_, record) => (
                <div className="channelBox">
                    <p style={{ color: '#666' }}>
                        {record.typeName} / {record.position1Name} / {record.position2Name}
                    </p>
                </div>
            ),
        },
        {
            title: '创建人',
            dataIndex: 'deleteStatus',
            render: (_, record) => (
                <div>
                    <p>{record.createdByStaffName}</p>
                    <p>{record.createTime}</p>
                </div>
            ),
        },
        {
            title: '状态',
            dataIndex: 'type',
            render: (_, record) => <div>{record.deleteStatus === 0 ? <p className="enable">启用</p> : <p className="disable">禁用</p>}</div>,
        },
        {
            title: '操作',
            dataIndex: 'operation',
            fixed: 'right',
            width: 240,
            render: (_, record) => {
                const items =
                    record.deleteStatus === 0
                        ? [
                              {
                                  label: '禁用渠道',
                                  key: 'disable',
                                  danger: true,
                                  onClick: () => handleDisableChannel(record),
                              },
                          ]
                        : [
                              {
                                  label: '启用渠道',
                                  key: 'enable',
                                  onClick: () => handleEnableChannel(record),
                              },
                          ];

                return (
                    <Space className="operation-btns" separator={<Divider orientation="vertical" />}>
                        <Button size="small" type="link" onClick={() => handleEditClick(record)}>
                            编辑
                        </Button>
                        {record.deleteStatus === 0 && (
                            <Button size="small" type="link" onClick={() => handleGenerateChannelLink(record)}>
                                生成渠道链接
                            </Button>
                        )}
                        <Dropdown menu={{ items }} placement="bottomRight">
                            <Button type="link" size="small" className="more-operation">
                                <i className="bi bi-three-dots"></i>
                            </Button>
                        </Dropdown>
                    </Space>
                );
            },
        },
    ];

    const refresh = () => {
        changeCurrPage(1);
    };

    const changeCurrPage = useCallback(page => {
        setPage(page);
    }, []);

    const changePageSize = useCallback(pageSize => {
        setLimit(pageSize);
    }, []);

    const paginationProps = {
        ...fullPagerConfig,
        showSizeChanger: { placement: 'topRight' },
        current: page,
        pageSize: limit,
        size: 'small',
        total: list?.totalCount,
        onShowSizeChange: (_current, pageSize) => changePageSize(pageSize),
        onChange: page => {
            changeCurrPage(page);
        },
    };

    const onCloseDrawer = () => {
        setIsShowDrawer(false);
        setIsShowCode(false);
    };

    const onFinishUrl = values => {
        const str = /^https?:\/\/.+?\.cn-healthcare\.com/i;
        if (str.test(values.url)) {
            if (values.url.includes('?')) {
                setCodeValue(`${values.url}&chid=${channelInformation.id}`);
            } else {
                setCodeValue(`${values.url}?chid=${channelInformation.id}`);
            }
            setIsShowCode(true);
        } else {
            setIsShowCode(false);
            message.info('链接验校失败，目前只支持 cn-healthcare.com 域名链接');
        }
    };

    const changeInput = () => {
        setIsShowCode(false);
    };

    const addUrl = i => {
        const value = ulrList[i];
        formUrl.setFieldsValue({ url: value });
        setIsShowCode(false);
    };

    const onSearch = async value => {
        const text = String(value ?? '');
        try {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(text);
                message.success('复制成功');
                return;
            }
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'fixed';
            textarea.style.top = '0';
            textarea.style.left = '-9999px';
            document.body.appendChild(textarea);
            textarea.select();
            const ok = document.execCommand('copy');
            document.body.removeChild(textarea);
            ok ? message.success('复制成功') : message.error('复制失败，请手动复制');
        } catch (err) {
            console.error('复制失败', err);
            message.error('复制失败，请手动复制');
        }
    };

    const clickDownLoad = () => {
        var Qr = document.getElementById('qrid');
        const image = new Image();
        image.src = Qr.toDataURL('image/png');
        var a_link = document.getElementById('aId');
        a_link.href = image.src;
    };

    return (
        <div className="page-container channel-list-page">
            <PageHeader title="渠道管理" breadcrumb={[{ label: '运营中心', path: '/operation/channels' }, { label: '渠道管理' }]} {...filterToggleProps} />

            <FilterPanelSlot>
                <ChannelFilterPanel filter={filter} onFinish={onFinish} onReset={onReset} treeData={treeData} dataList={dataList} />
            </FilterPanelSlot>

            <div ref={tableRegionRef} className="channel-list-table-region">
                <div className="main-toolbar channel-list-table-toolbar channel-list-toolbar">
                    <div className="main-tools">
                        <Button type="primary" onClick={newChannels}>
                            新增渠道
                        </Button>
                    </div>
                    <div className="sub-tools">
                        <Space>
                            <Tooltip title="刷新列表">
                                <Button type="default" onClick={refresh} icon={<span className="bi bi-arrow-clockwise" aria-hidden="true" />} aria-label="刷新列表" />
                            </Tooltip>
                            <Tooltip title={isFullscreen ? '退出全屏' : '全屏'}>
                                <Button type="default" onClick={handleToggleFullscreen} icon={<span className={isFullscreen ? 'bi bi-fullscreen-exit' : 'bi bi-fullscreen'} aria-hidden="true" />} aria-label={isFullscreen ? '退出全屏' : '全屏'} />
                            </Tooltip>
                        </Space>
                    </div>
                </div>

                <div className="channel-list-table-wrap channel-list">
                    <Table
                        className={tableScrollY != null ? 'custom-table-scrollbar-always' : undefined}
                        rowKey="id"
                        columns={columns}
                        dataSource={list?.list}
                        pagination={paginationProps}
                        bordered
                        sticky
                        size="medium"
                        scroll={{
                            x: 'max-content',
                            ...(tableScrollY != null ? { y: tableScrollY } : {}),
                        }}
                    />
                </div>
            </div>

            {isShowEdit && (
                <Modal title="编辑渠道" open={isShowEdit} onCancel={handleCancelEdit} footer={null}>
                    <Form {...filterFormItemLayout} onFinish={onFinishEdit} form={form2}>
                        <Form.Item label="渠道名称" name="title" rules={[{ required: true, message: '输入渠道名称' }]}>
                            <Input allowClear placeholder="输入渠道名称" />
                        </Form.Item>

                        <Form.Item label="渠道分类" name="position2" rules={[{ required: true, message: '选择所属渠道分类' }]}>
                            {treeDataDisabled && <TreeSelect style={{ width: '100%' }} value={valueSelectEdit} styles={{ popup: { root: { maxHeight: 400, overflow: 'auto' } } }} treeData={treeDataDisabled} placeholder="选择渠道分类" treeDefaultExpandAll={true} onChange={onChangeTreeSelectEdit} />}
                        </Form.Item>
                        <Form.Item {...pageFormItemWithoutLabelGridLayout}>
                            <Space>
                                <Button onClick={handleCancelEdit}>取消</Button>
                                <Button type="primary" htmlType="submit">
                                    确定
                                </Button>
                            </Space>
                        </Form.Item>
                    </Form>
                </Modal>
            )}

            {isShowNewChannel && (
                <Modal title="新增渠道" open={isShowNewChannel} onCancel={handleCancelChannel} centered footer={null}>
                    <Form {...filterFormItemLayout} onFinish={onFinishChannel} form={form3}>
                        <Form.Item label="渠道名称" name="title" rules={[{ required: true, message: '输入渠道名称' }]}>
                            <Input allowClear placeholder="输入渠道名称" />
                        </Form.Item>

                        <Form.Item label="渠道分类" rules={[{ required: true, message: '选择所属渠道分类' }]} name="position2">
                            {treeDataDisabled && (
                                <TreeSelect
                                    style={{ width: '100%' }}
                                    value={valueSelectChannel}
                                    styles={{ popup: { root: { maxHeight: 400, overflow: 'auto' } } }}
                                    treeData={treeDataDisabled}
                                    placeholder="选择渠道分类"
                                    showSearch={{ filterTreeNode: filterTreeNodeByTitle }}
                                    treeDefaultExpandAll={true}
                                    onChange={onChangeTreeSelectChannel}
                                />
                            )}
                        </Form.Item>
                        <Form.Item {...pageFormItemWithoutLabelGridLayout}>
                            <Space>
                                <Button onClick={handleCancelChannel}>取消</Button>
                                <Button type="primary" htmlType="submit">
                                    确定
                                </Button>
                            </Space>
                        </Form.Item>
                    </Form>
                </Modal>
            )}

            {isShowDrawer && (
                <Drawer title="生成渠道链接" placement="right" onClose={onCloseDrawer} open={isShowDrawer} size={drawerWidth} closable={{ placement: 'end' }}>
                    <Form form={formUrl} onFinish={onFinishUrl} {...filterFormItemLayout}>
                        <Form.Item label="渠道信息" {...filterFormItemLayout}>
                            {channelInformation.title} [#{channelInformation.id}]
                        </Form.Item>
                        <Form.Item label="常用链接" {...filterFormItemLayout}>
                            <a onClick={addUrl.bind(this, 0)}>认证链接</a> <a onClick={addUrl.bind(this, 1)}>注册链接</a> <a onClick={addUrl.bind(this, 2)}>会员开通链接</a>
                        </Form.Item>{' '}
                        <Form.Item label="原始链接" name="url" rules={[{ required: true, message: '原始链接不能为空' }]} {...filterFormItemLayout}>
                            <Input allowClear placeholder="请输入要推广的原始链接" onChange={changeInput} />
                        </Form.Item>
                        <Form.Item {...filterFormItemLayout} label="">
                            <Button type="primary" htmlType="submit" style={{ marginLeft: 150 }}>
                                生成渠道链接
                            </Button>
                        </Form.Item>
                    </Form>
                    {isShowCode && (
                        <Form {...filterFormItemLayout}>
                            <Form.Item label="渠道链接" {...filterFormItemLayout}>
                                <div>
                                    <Input allowClear value={codeValue} disabled style={{ width: '80%' }} />
                                    <span className="copyElement" onClick={onSearch.bind(this, codeValue)}>
                                        复制
                                    </span>
                                </div>
                            </Form.Item>
                            <Form.Item label="渠道二维码" {...filterFormItemLayout}>
                                <QRCode id="qrid" value={codeValue} size={300} fgColor="#000000" bgColor="#fff" includeMargin={true} />
                                <div>
                                    <a download id="aId">
                                        <Button onClick={clickDownLoad}>
                                            <i className="bi bi-download"></i>
                                            下载
                                        </Button>
                                    </a>
                                </div>
                            </Form.Item>
                        </Form>
                    )}
                </Drawer>
            )}
        </div>
    );
}
